import baseApi from "../api/baseApi";

export const resetApiCache = () => {
  import("../../store/store").then((module) => {
    module.default.dispatch(baseApi.util.resetApiState());
  });
};
